module.exports = __webpack_public_path__ + "img/insert-02-droit.2edd7045.svg";